import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"dashboard\"><div class=\"container\"><div class=\"dashboard-text d-flex align-items-start flex-column\"><div class=\"mt-auto p-2 bd-highlight\"><a class=\"dashboard-link\" id=\"request-information\" target=\"_blank\" href=\"https://www.dnv.com/software/contact/request-information-sesam.html?RequestId=1068&amp;t=ServiceLine\"><button class=\"btn btn-cta\">Request Information <i class=\"fal fa-arrow-right\"></i></button></a></div><div class=\"p-2 bd-highlight\"><a class=\"dashboard-link\" id=\"digital-marketplace\" target=\"_blank\" href=\"https://store.veracity.com/?query=sesam\"><button class=\"btn btn-cta\">Sesam Digital Marketplace <i class=\"fal fa-arrow-right\"></i></button></a></div><div class=\"p-2 bd-highlight\"> Structural analysis on premise and in the cloud. Collaboration on engineering projects with all stakeholders. Visualisation of assets and results in a web browser on any device. </div></div></div></div>", 1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-start justify-content-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "sesam-news" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "./download/documents/LatestNews.pdf",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "alert alert-info",
          role: "alert"
        }, [
          /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle info" }),
          /*#__PURE__*/_createElementVNode("strong", null, "Software News!"),
          /*#__PURE__*/_createTextVNode(" Click here to read about the recent major enhancements in our software "),
          /*#__PURE__*/_createElementVNode("br")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-start justify-content-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "section-header section-header-launch-apps" }, "Launch Applications")
  ])
], -1)
const _hoisted_5 = { class: "row justify-content-md-start justify-content-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-start justify-content-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "section-header" }, "Help and Knowledge")
  ])
], -1)
const _hoisted_7 = { class: "row justify-content-md-start justify-content-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-start justify-content-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "section-header" }, "Documents"),
    /*#__PURE__*/_createElementVNode("div", { class: "divider" })
  ])
], -1)
const _hoisted_9 = { class: "row justify-content-md-start justify-content-center" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-md-start justify-content-left\"><div class=\"col-md-6 videos\"><p class=\"section-header\">Videos <span class=\"link link-videos\"><a href=\"https://www.dnv.com/videos?QueryString=sesam\" id=\"view-all-videos\" target=\"_blank\">View all videos</a></span></p></div><div class=\"col-md-12\"><div class=\"divider\"></div></div></div>", 1)
const _hoisted_11 = { class: "row justify-content-md-start justify-content-center" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-md-start justify-content-left\"><div class=\"col-md-4\"><p class=\"section-header\">Featured Sesam Products</p></div><div class=\"col-md-12\"><div class=\"divider\"></div></div></div>", 1)
const _hoisted_13 = { class: "row justify-content-md-start justify-content-left" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-md-start justify-content-left\"><div class=\"col-md-7\"><p class=\"link link-browse\"><a href=\"https://www.dnv.com/sesam\" id=\"browse-sesam-suite\" target=\"_blank\">Browse the complete Sesam software suite and engage with our sales department <i class=\"fal fa-arrow-right\"></i></a></p></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!
  const _component_HelpCard = _resolveComponent("HelpCard")!
  const _component_DocumentationLink = _resolveComponent("DocumentationLink")!
  const _component_VideoCard = _resolveComponent("VideoCard")!
  const _component_FeaturedCard = _resolveComponent("FeaturedCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ApplicationCard, {
          name: "Sesam Insight",
          url: _ctx.exploreUrl,
          description: "View, share and collaborate on models and results",
          image: "sesam-insight-compressed.png",
          id: "sesam-insight"
        }, null, 8, ["url"]),
        _createVNode(_component_ApplicationCard, {
          name: "Sesam Cloud Compute Services",
          url: _ctx.computeUrl,
          description: "Run structural analyses in the cloud",
          image: "GettyImages-1157048386.jpg",
          id: "compute-portal"
        }, null, 8, ["url"])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_HelpCard, {
          title: "Downloads",
          description: "Download applications and packages",
          icon: "fa-download",
          url: "/download/programs.html",
          id: "downloads"
        }),
        _createVNode(_component_HelpCard, {
          title: "Status Lists",
          description: "Check out the latest application updates and key information",
          icon: "fa-bullhorn",
          url: "/status/status.html",
          id: "status-lists"
        }),
        _createVNode(_component_HelpCard, {
          title: "Examples",
          description: "Learn how to use the applications through examples",
          icon: "fa-wind-turbine",
          url: "/examples/examples.html",
          id: "examples"
        }),
        _createVNode(_component_HelpCard, {
          title: "License Troubleshooting",
          description: "Troubleshoot licensing problems",
          icon: "fa-key",
          url: "/support/LicenseTroubleshooting_StandaloneLicense.html",
          id: "license-troubleshooting"
        }),
        _createVNode(_component_HelpCard, {
          title: "Sesam.Starter",
          description: "Introductory tool for structural analysis with Sesam",
          icon: "fa-bolt",
          url: "/examples/sesamstarter/sesamstarter.html",
          id: "sesam-starter"
        }),
        _createVNode(_component_HelpCard, {
          title: "GeniE Snack Pack",
          description: "Access utilities, examples and special functions",
          icon: "fa-popcorn",
          url: "/genie_utils/index.html",
          id: "genie-snackpack"
        }),
        _createVNode(_component_HelpCard, {
          title: "Customer Portal",
          description: "Visit our knowledge sharing and technical support portal",
          icon: "fa-laptop",
          url: "https://www.dnv.com/cp",
          id: "customer-portal"
        }),
        _createVNode(_component_HelpCard, {
          title: "Training",
          description: "View our instructor-led and self-guided training courses",
          icon: "fa-chalkboard-teacher",
          url: "/training/training.html",
          id: "training"
        }),
        _createVNode(_component_HelpCard, {
          title: "Contact Support",
          description: "Need help? Get in touch with our experts",
          icon: "fa-user-headset",
          url: "https://www.dnv.com/software/software-services/software-support.html",
          id: "contact-support"
        })
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_DocumentationLink, {
          title: "Software News 2023",
          url: "/download/documents/ROS_SoftwareNews_2023.pdf",
          id: "rosNewsQ42022"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Software News Q4 2022",
          url: "/download/documents/ROS_SoftwareNews_Q4_2022.pdf",
          id: "rosNewsQ42022"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Software News Q1 2022",
          url: "/download/documents/ROS_SoftwareNews_Q1_2022.pdf",
          id: "rosNewsQ12022"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Software News Q2 2021",
          url: "/download/documents/SesamNewsQ22021.pdf",
          id: "sesamNewsQ22021"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Sesam.Starter Documentation",
          url: "https://myworkspace.dnv.com/download/sesam/user-manual/sesam-starter/Overview.html",
          id: "sesamStarter"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Sesam Package Description",
          url: "/download/documents/SesamPackageDescription.pdf",
          id: "packageDescription"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Sesam Feature Description",
          url: "/download/documents/SesamFeatureDescription.pdf",
          id: "features"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Sesam Input Interface Format",
          url: "/download/windows64/sesam_input_interface_format.pdf",
          id: "features"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "Sesam Results Interface Format",
          url: "/download/windows64/sesam_results_interface_format.pdf",
          id: "features"
        }),
        _createVNode(_component_DocumentationLink, {
          title: "SifIO Python API",
          url: "https://pypi.org/project/dnv-sifio/",
          id: "sifio"
        })
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_VideoCard, {
          title: "Tubular Joint Modelling",
          brandCentralId: "https://brandcentral.dnv.com/mars/embed?o=41C7BBEFF5BA6A4C&c=10651&a=N",
          length: "15:03 min",
          id: "Tubular Joint Modelling"
        }),
        _createVNode(_component_VideoCard, {
          title: "FLS Visualisation in Sesam Insight",
          brandCentralId: "https://brandcentral.dnv.com/mars/embed?o=BE16F5EBAD6487F9&c=10651&a=N",
          length: "10:16 min",
          id: "video-insight-fls"
        }),
        _createVNode(_component_VideoCard, {
          title: "Sesam.Starter in action",
          brandCentralId: "https://brandcentral.dnv.com/mars/embed?o=9653975393A3AEB7&c=10651&a=N",
          length: "18:17 min",
          id: "video-sesam-starter"
        })
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_FeaturedCard, {
          title: "Sesam for Offshore Wind",
          description: "Software for the development of offshore wind farms",
          image: "offshore-wind.jpg",
          url: "https://www.dnv.com/software/services/software-for-offshore-wind/index.html",
          id: "sesam-wind"
        }),
        _createVNode(_component_FeaturedCard, {
          title: "Sesam for Floating Structures",
          description: "A complete solution for floating structure design and analysis",
          image: "floating-structures.jpg",
          url: "https://www.dnv.com/services/floating-structure-design-and-modification-sesam-for-floating-structures-2410",
          id: "sesam-floating"
        }),
        _createVNode(_component_FeaturedCard, {
          title: "Sesam for Fixed Structures",
          description: "Software solutions for structural design, operation and life extension analysis",
          image: "fixed-structures.jpg",
          url: "https://www.dnv.com/software/services/software-for-design-operation-and-life-extension/index.html",
          id: "sesam-fixed"
        })
      ]),
      _hoisted_14
    ])
  ], 64))
}